import { useMutation } from "@tanstack/react-query";
import i18n from "i18n";
import fetch from "logic/rest/FetchProvider";
import { qualifyUrl } from "util/URLUtils";
import UserNotification from "util/UserNotification";
export const urlPrefix = "/system/indices/mappings";
const putFieldType = async ({ indexSetSelection, newFieldType, rotated, field }) => {
  const url = qualifyUrl(urlPrefix);
  const body = {
    index_sets: indexSetSelection,
    type: newFieldType,
    rotate: rotated,
    field
  };
  return fetch("PUT", url, body);
};
const usePutFieldTypeMutation = () => {
  const put = useMutation({
    mutationFn: putFieldType,
    onError: (errorThrown) => {
      UserNotification.error(
        i18n.t("change_field_type.change_failed", { ns: "search", error: errorThrown }),
        i18n.t("change_field_type.change_failed_title", { ns: "search" })
      );
    },
    onSuccess: () => {
      UserNotification.success(
        i18n.t("change_field_type.change_success", { ns: "search" }),
        i18n.t("change_field_type.success_title", { ns: "search" })
      );
    }
  });
  return { putFieldTypeMutation: put.mutateAsync, isLoading: put.isPending };
};
export default usePutFieldTypeMutation;
